import { Map } from 'immutable';
import {
    MT_GET_SERVER_LIST,
    MT_GET_ACCOUNT_TYPE,
    MT_GET_SERVER_ACCOUNT_TYPE,
    MT_GET_USED_TRADE_PLATFORM,
    MT_GET_SERVER,
    MT_GET_ALIAS,
    MT_GET_CONFIG,
    MT_GET_VIRTUAL_GROUP
} from '../actions/mt';
import { APP_RESET } from '../actions/reset';
import { createActionHandler, createAsyncActionHandler } from './creator';

const initial = Map({
    isGettingServerList: false,
    isGettingAccountType: false,
    isGettingServerAccountType: false,
    isGettingUsedTradePlatform: false,
    isGettingServer: false,
    isGettingAlias: false,
    isGettingMtConfig: false,
    isGettingVirtualGroup: false,
    mtConfig: [],
    serverList: {},
    accountType: {},
    serverAccountType: {},
    virtualGroup: {},
    usedAccountType: {},
    tradeAccount: {},
    usedTradePlatform: [],
    servers: {},
    serversGroup: {},
    serverMap: Map({}),
    accountAlias: [],
    mtList: []
});

const handlers = {
    ...createActionHandler(APP_RESET, () => initial),

    // 获取MT列表[platform-server]
    ...createAsyncActionHandler(MT_GET_CONFIG, {
        init: (state: any) => state.merge({
            isGettingMtConfig: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingMtConfig: false,
            usedTradePlatform: action.payload.platforms,
            serversGroup: action.payload.servers
        }),
        failed: (state: any) => state.merge({
            isGettingMtConfig: false
        })
    }),

    // 获取交易账户类型列表
    ...createAsyncActionHandler(MT_GET_ACCOUNT_TYPE, {
        init: (state: any) => state.merge({
            isGettingAccountType: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingAccountType: false,
            accountType: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingAccountType: false
        })
    }),

    // 获取虚拟组别列表
    ...createAsyncActionHandler(MT_GET_VIRTUAL_GROUP, {
        init: (state: any) => state.merge({
            isGettingVirtualGroup: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingVirtualGroup: false,
            virtualGroup: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingVirtualGroup: false
        })
    }),

    // 获取交易服务器列表
    ...createAsyncActionHandler(MT_GET_SERVER_LIST, {
        init: (state: any) => state.merge({
            isGettingServerList: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingServerList: false,
            mtList: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingServerList: false
        })
    }),

    // 获取服务器设置账户类型列表
    ...createAsyncActionHandler(MT_GET_SERVER_ACCOUNT_TYPE, {
        init: (state: any) => state.merge({
            isGettingServerAccountType: true,
            serverAccountType: {}
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingServerAccountType: false,
            serverAccountType: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingServerAccountType: false
        })
    }),

    // 获可用交易平台
    ...createAsyncActionHandler(MT_GET_USED_TRADE_PLATFORM, {
        init: (state: any) => state.merge({
            isGettingUsedTradePlatform: true,
            usedTradePlatform: []
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingUsedTradePlatform: false,
            usedTradePlatform: action.payload
        }),
        failed: (state: any, action: Action.Sync) => state.merge({
            isGettingUsedTradePlatform: false,
            usedTradePlatform: action.payload
        })
    }),
    // 获取交易平台对应服务器
    ...createAsyncActionHandler(MT_GET_SERVER, {
        init: (state: any) => state.merge({
            isGettingServer: true
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingServer: false,
            servers: { ...state.servers, ...action.payload }
        }),
        failed: (state: any) => state.merge({
            isGettingServer: false
        })
    }),
    // 获取账号类型的账号组别
    ...createAsyncActionHandler(MT_GET_ALIAS, {
        init: (state: any) => state.merge({
            isGettingAlias: true,
            accountAlias: []
        }),
        succeeded: (state: any, action: Action.Sync) => state.merge({
            isGettingAlias: false,
            accountAlias: action.payload
        }),
        failed: (state: any) => state.merge({
            isGettingAlias: false
        })
    }),
};

export const mt = initial;
export default (state = mt, action: any = {}): any => {
    const fn = handlers[action.type];
    return fn ? fn(state, action) : state;
};
